import React from 'react';
import { InfoTermElement } from '@app/common';
import TextWithReferences from '../TextWithReferences/TextWithReferences';

type Properties = {
    data: InfoTermElement;
};

const InfoTerm = (props: Properties) => {
    const { term, desc, centered } = props.data;

    const [showDescription, setShowDescription] = React.useState<boolean>(false);
    const toggleDescrtiption = () => {
        setShowDescription(!showDescription);
    };

    let termClassName = 'page-info-term';
    let descClassName = 'page-info-term-desc';
    if (centered) {
        termClassName += ' page-info-term-centered';
        descClassName += ' page-info-term-centered';
    }

    const descriptionElement = <div className={descClassName}>
        <TextWithReferences text={desc} />
    </div>;

    return (<>
        <div className={termClassName}>
            <div className="page-info-term-term">
                {term}
            </div>
            <img
                className="page-info-term-ibutton"
                onClick={toggleDescrtiption}
            />
        </div>
        {showDescription && descriptionElement}
    </>);
};

export default InfoTerm;
